import news1 from './../assets/news/news.jpg';
import news2 from './../assets/news/news2.png'
import meeting from './../assets/news/meeting.jpeg'
import night from './../assets/news/night.jpg'
import baoSteel from './../assets/news/baoSteel.jpg'
import visitor from './../assets/news/visitor.jpg'
import adobe1 from './../assets/news/adobe-1.jpg'
import dean from './../assets/news/dean.jpg'
import img020924 from './../assets/news/020924.jpeg'
import confer from './../assets/news/content/03-10-24.jpg'
import device from './../assets/news/news-08-07-2025.png';
import battery from './../assets/news/news-03-07-2025.png';
import image020725 from './../assets/news/news-02-07-2025.png';
import aepa2026 from './../assets/news/aepa2026.jpg';
import bajc from './../assets/news/BAJC_thumbnail.jpg';
import image11 from './../assets/news/5-3-2026.jpg';
import image12 from './../assets/news/05_03_2026.jpg';
import image13 from './../assets/news/title image WSU visit .jpg';
import image14 from './../assets/news/29June26.png';
import new260626 from './../assets/news/content/260626.pdf';
import news021026 from './../assets/news/news-02-10-26.JPG';

export const news = [
  // next id: 15
  {
    img: news021026,
    date: "28 Sept - 2 Oct 2026",
    description: "Creating impact from Wollongong",
    id: 14,
  },
  {
    img: image14,
    date: "9 July 2026",
    description: "Future of Manufacturing and Mining Workshop will be held at UOW",
    url: new260626,
  },
  {
    img: image13,
    date: "17 March 2026",
    description: "Well done Team WSU – Distinguished Professor Zhengyi Jiang visited WSU",
    id: 13
  },
      {
    img: image12,
    date: "5 March 2026",
    description: "Centre ICHDR candidate won prestigious award",
    id: 12
  },
      {
    img: image11,
    date: "5 March 2026",
    description: "China Baowu Steel visited ARC Centre (Composites for Mining Equipment) at UOW",
    id: 11
  },
    {
    img: bajc,
    date: "2-4 March 2026",
    description: "BAJC Conference 2026",
    id: 10
  },
  {
    img: aepa2026,
    date: "1-6 Feb 2026",
    description: "The ARC composites for Mining Equipment hosted AEPA 2026 in Auckland NZ",
    id: 9
  },
  {
    img: device,
    date: "8 July 2025",
    description: "Jiangsu Industrial Technology Research Institute visit",
    id: 8
  },
  {
    img: battery,
    date: "3 July 2025",
    description: "Bao Steel Researcher visit",
    id: 7
  },
  {
    img: image020725,
    date: "2 July 2025",
    description: "Zhengzhou University visit",
    id: 6,
  },
  {
    img: confer,
    date: "3 October 2024",
    description: "Green Mining Conference 2024 and First HDR Forum of ARC ITTC for Innovative Composites for Sustainable Mining. ",
    id: 5
  },
  {
    img: img020924,
    date: "2 September 2024",
    description: "A new industry partner joined ARC Innovative Composites for Sustainable Mining Equipment.",
    id: 4
  },
  {
    img: dean,
    date: "21 August 2024",
    description: "The Centre welcomed the Dean of Engineering from Curtin University.",
    id: 3
  },
  {
    img: visitor,
    date: "20 August 2024",
    description: "Distinguished Visitor of the Centre: Professor Yuanping Cheng of China University of Mining and Technology (CUMT) 's visit",
    id: 0
  },
  {
    img: adobe1,
    date: "9 August 2024",
    description: "Use manufacturing technologies to achieve 2050 net zero carbon target in a rural setting",
    id: 1
  },
  {
    url: "https://www.linkedin.com/feed/update/urn:li:activity:7217392765305856000/?actorCompanyId=99349140",
    img: meeting,
    date: "5 July, 2024",
    description: "UOW works with its industry partner HBIS to develop clean metal technologies"
  },
  {
    url: "https://portal.engineersaustralia.org.au/event/2023/09/rtsa-student-rail-industry-networking-night-51281",
    img: night,
    date: "2024",
    description: "RTSA student rail industry networking night"
  },
  {
    url: "https://www.uow.edu.au/media/2024/uow-led-project-to-create-cleaner-greener-stainless-steel-manufacturing-process-.php",
    img: news2,
    date: "25 June, 2024",
    description: "The Australian Research Council (ARC) last week (Friday 21 June) announced the recipients of the Linkage Project Scheme Round 2, with the UOW project sharing in $43-million worth of funding."
  },
  {
    img: baoSteel,
    date: "21 June 2024",
    description: "The world's largest steel producer funds UOW to undertake low carbon emission research projects",
    id: 2
  },
  {
    url: "https://www.australianmanufacturing.com.au/university-of-wollongong-houses-new-arc-training-centre-for-sustainable-mining/",
    img: news1,
    date: "12 October, 2023",
    description: "The University of Wollongong's Innovation Campus is now home to the Australian Research Council's new Training Centre for Innovative Composites for the Future of Sustainable Mining Equipment. "
  },
]
